/* global hbspt */
const {KitModule, registerModule} = window;

class HubspotForm extends KitModule {
  /**
   * @param {HTMLElement} $element
   */
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
    this.init();
  }

  bindEvents() {
    window.addEventListener('message', (event) => {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
        this.handleFormReady();
      }
    });
  }

  /**
   * If the URL includes a hash (an element with an anchor link), scroll that
   * element into view after the form successfully loads.
   */
  handleFormReady() {
    if (this.scrollToHash) {
      const $anchorElement = document.getElementById(this.hash);
      if ($anchorElement) {
        $anchorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }


  /**
   * Call the HubSpot create form function
   */
  init() {
    if (!window.hbspt?.forms) {
      // Display fallback content if the HubSpot script failed to load (ex. if
      // the user has content blockers enabled in their browser)
      this.$fallback.setAttribute('aria-hidden', false);
      return;
    }

    if (!this.formId || !this.portalId) {
      /* eslint-disable-next-line no-console */
      console.log('Unexpected form configuration:', {
        formId: this.formId,
        portalId: this.portalId,
        region: this.region,
      });
      return;
    }

    // Do Not Track - tells the HubSpot tracking code (if present) not to
    // collect analytics for this visitor. The form itself is unaffected.
    window._hsq = window._hsq || [];
    window._hsq.push(['doNotTrack']);

    hbspt.forms.create({
      formId: this.formId,
      portalId: this.portalId,
      region: this.region,
      target: `[data-hubspot-form='${this.formId}']`,
    });

    if (this.scrollToHash) {
      setTimeout( () => {
        // Cancel automatic scrolling if the form hasn't loaded after two
        // seconds, at which point the user may have begun to scroll aroudn
        // manually.
        this.scrollToHash = false;
      }, 2000);
    }
  }

  setVars() {
    this.formId = this.$element.dataset.formId;
    this.portalId = this.$element.dataset.portalId;
    this.region = this.$element.dataset.region;

    const {hash} = new URL(window.location.href);
    this.hash = hash.replace('#', '');
    this.scrollToHash = this.hash ? true : false;
  }
}

registerModule('HubspotForm', HubspotForm);
